import { siteVariant, type PageConfig } from './variants';

export type { PageConfig, SiteVariant, SiteVariantId } from './variants';
export { ONF_CLOSED_TRAILS_URL, SITE_EMAIL } from './variants';

/** The variant this bundle was built for (VITE_SITE_VARIANT, `tipa` by default). */
export const site = siteVariant(import.meta.env.VITE_SITE_VARIANT as string | undefined);
export const PAGES: PageConfig[] = site.pages;
export const SITE_NAME = site.name;

export function pageTitle(page: PageConfig | string): string {
    if (typeof page !== 'string' && page.path === '/') return site.homeTitle;
    const title = typeof page === 'string' ? page : page.title;
    return `${title} | ${site.name}`;
}
